import { render, staticRenderFns } from "./breakingNews.vue?vue&type=template&id=612de640&scoped=true"
import script from "./breakingNews.vue?vue&type=script&lang=js"
export * from "./breakingNews.vue?vue&type=script&lang=js"
import style0 from "./breakingNews.vue?vue&type=style&index=0&id=612de640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612de640",
  null
  
)

export default component.exports